<template>
  <div>
    <div>
      <v-tooltip bottom v-if="outOfRange">
        <template v-slot:activator="{ on, attrs }">
          <span class="criteria-value out-of-range" :class="{'unknown': (displayName === 'unknown'), 'expired-value': (isSourceValue && valueExpired)}" v-bind="attrs" v-on="on">
            {{ displayName }}
          </span>
        </template>
        <span>This value looks like it is outside your range {{rangeText}}</span>
      </v-tooltip>
      <span v-else class="criteria-value" :class="{'unknown': (displayName === 'unknown'), 'expired-value': (isSourceValue && valueExpired)}">
        <v-icon
          v-if="keywordOnly && displayName !== 'unknown'"
          :color="displayName === 'YES' ? 'success' : 'danger'"
        >
          {{ displayName === 'YES' ? 'mdi-check' : 'mdi-close' }}
        </v-icon>
        <div v-else>
          {{ displayName }}
        </div>
      </span>
      <span v-if="showLastValue" :class="computedLastValueClass">
        {{ lastValueDisplayName }}
      </span>
    </div>
    <slot name="options"></slot>
  </div>
</template>


<script>
import checkInRange from '@/mixins/ValueInRange.js'

export default {
  name: 'CriteriaValue',
  mixins: [checkInRange],
  props: {
    value: Object,
    lastValue: Object,
    lastValueClass: String,
    showValueChanges: {
      type: Boolean,
      default: false
    },
    valueExpired: {
      type: Boolean,
      default: false
    },
    range: Object,
    keywordOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedLastValueClass: function () {
      return this.lastValueClass ? this.lastValueClass : 'fallback-last-val'
    },
    outOfRange: function () {
      return this.range ? !this.valueInRange(this.displayName, this.range) : false
    },
    rangeText: function () {
      return this.range ? `${this.range.min} - ${this.range.max}` : ''
    },
    showLastValue: function () {
      return this.showValueChanges && this.displayName !== this.lastValueDisplayName
    },
    displayName: function () {
      let res = 'unknown'
      // User values override values generated from a source document or url
      if (this.value && this.keywordOnly) {
        if (this.value.sourceValue) {
          res = 'YES'
        } else {
          // res = this.value.userValue ? 'YES' : 'NO'
          if (this.value.userValue) {
            res = this.value.userValue === 'NO' ? this.value.userValue : 'YES'
          } else {
            res = 'NO'
          }
        }
      } else if (this.value && this.value.userValue) {
        res = this.value.userValue
      } else if (this.value && this.value.sourceValue) {
        res = this.value.sourceValue
      }
      return res
    },
    isSourceValue: function () {
      return (this.value && !this.value.userValue && this.value.sourceValue) ? true : false
    },
    lastValueDisplayName: function () {
      let res = 'unknown'
      // User values override values generated from a source document or url
      if (this.lastValue && this.keywordOnly) {
        if (this.lastValue.sourceValue) {
          res = 'YES'
        }
        else {
          if (this.lastValue.userValue) {
            res = this.lastValue.userValue === 'NO' ? this.lastValue.userValue : 'YES'
          } else {
            res = 'NO'
          }
        }
      } else if (this.lastValue && this.lastValue.userValue) {
        res = this.lastValue.userValue
      } else if (this.lastValue && this.lastValue.sourceValue) {
        res = this.lastValue.sourceValue
      }
      return res
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.criteria-value {
  font-weight: 400;
  color: #222;

  &.unknown {
    font-weight: 400;
    color: #CCC;
  }
}
.fallback-last-val {
  color: #CCC;
  text-decoration: line-through;
}
.out-of-range {
  color: #f44336 !important;
}
.expired-value {
  color: #ff9800;
  text-decoration: line-through;
}
</style>
